import Doctor from "../assets/images/about/01.jpeg";
import Counter from '../components/Counter';
import Banner from "../assets/images/banner/page_banner.jpg";

const About = () => {
  return (
    <div className="bg-white">

      {/* HERO SECTION */}
      <section className="relative h-[420px] flex items-center justify-center text-white">

        {/* background */}
        <div className="absolute inset-0">
          <img
            src={Banner}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-primary/80"></div>
        </div>

        <div className="relative text-center mt-20">
          <h1 className="text-5xl font-black">About Doctor</h1>
          <p className="mt-3 text-lg opacity-90">
            Urologist, Andrologist & Kidney Transplant Surgeon
          </p>
        </div>
      </section>

      {/* DOCTOR INTRO */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">

          {/* doctor image */}
          <div>
            <img
              src={Doctor}
              className="rounded-3xl shadow-2xl w-full h-screen object-cover"
            />
          </div>

          {/* content */}
          <div>
            <h2 className="text-4xl font-black text-slate-900">
              Dr. Sachitanand Chaurasia
            </h2>

            <p className="text-primary font-semibold mt-2 text-lg">
              MBBS, MS, M.Ch (Urology)
            </p>

            <p className="text-slate-600 mt-6 leading-relaxed">
              Dr. Sachitanand Chaurasia is a dedicated and highly skilled Consultant Urologist & Andrologist committed to providing comprehensive and advanced urological care. With over 8+ years of experience in the field of urology, he has successfully treated thousands of patients with a wide range of urinary and male reproductive health conditions.
            </p>
            <p className="text-slate-600 mt-6 leading-relaxed">
              He completed his MBBS, MS, and MCh in Urology and has developed strong expertise in modern diagnostic and minimally invasive surgical techniques. Dr. Chaurasia specializes in the treatment of kidney stones through laser and endoscopic procedures (RIRS, PCNL), prostate enlargement (BPH) management including HOLEP, urinary tract infections, bladder and kidney disorders, male infertility, and sexual health concerns. His approach focuses on accurate diagnosis, advanced treatment, and faster recovery for patients.
            </p>
            <p className="text-slate-600 mt-6 leading-relaxed">
              Known for his compassionate and patient-friendly nature, Dr. Chaurasia believes in building trust through clear communication and personalized care. He ensures that every patient receives individual attention, proper guidance, and the most suitable treatment plan based on their specific condition and needs.
            </p>
            <p className="text-slate-600 mt-4 leading-relaxed">
              His goal is to deliver the highest standards of urological care with precision, safety, and excellence while improving the quality of life for every patient.
            </p>
            <p className="text-slate-600 mt-4 leading-relaxed">
              Dr. Sachitanand Chaurasia continues to stay updated with the latest advancements in urology to provide effective and reliable solutions for all urological problems, ensuring the best possible outcomes for his patients.
            </p>

            {/* highlights */}
            <div className="grid grid-cols-2 gap-6 mt-10">

              <div className="bg-lightBg p-6 rounded-2xl shadow-premium text-center">
                <h3 className="text-3xl font-bold text-primary">
                  <Counter value={8} suffix="+" />
                </h3>
                <p className="text-sm text-slate-500">Years Experience</p>
              </div>

              <div className="bg-lightBg p-6 rounded-2xl shadow-premium text-center">
                <h3 className="text-3xl font-bold text-primary">
                  <Counter value={10000} suffix="+" />
                </h3>
                <p className="text-sm text-slate-500">Happy Patients</p>
              </div>

              <div className="bg-lightBg p-6 rounded-2xl shadow-premium text-center">
                <h3 className="text-3xl font-bold text-primary">
                  <Counter value={10000} suffix="+" />
                </h3>
                <p className="text-sm text-slate-500">Successful Surgeries</p>
              </div>

              <div className="bg-lightBg p-6 rounded-2xl shadow-premium text-center">
                <h3 className="text-3xl font-bold text-primary">
                  24x7
                </h3>
                <p className="text-sm text-slate-500">Patient Support</p>
              </div>

            </div>

          </div>
        </div>
      </section>

      {/* TABS SECTION */}
      <section className="py-20 bg-lightBg">
        <div className="max-w-7xl mx-auto px-6">

          <h2 className="text-4xl font-black text-center mb-16">
            Education & Professional Details
          </h2>
          <div className="grid md:grid-cols-2 gap-x-12 gap-y-4">
            {/* EDUCATION */}
            <div className="bg-white rounded-3xl shadow-premium p-10 mb-8">
              <h3 className="text-2xl font-bold text-primary mb-8">Education</h3>

              <div className="border-l-4 border-primary ml-4 space-y-8">

                <div className="pl-8 relative">
                  <div className="absolute -left-3.5 top-1 w-6 h-6 bg-primary rounded-full"></div>
                  <p className="font-semibold">2011</p>
                  <p>MBBS – Grant Govt Medical College & JJ Hospital, Mumbai, Maharashtra</p>
                </div>

                <div className="pl-8 relative">
                  <div className="absolute -left-3.5 top-1 w-6 h-6 bg-primary rounded-full"></div>
                  <p className="font-semibold">2015</p>
                  <p>MS (General Surgery) – BJ Medical College & Sassoon Hospitals, Pune, Maharashtra</p>
                </div>

                <div className="pl-8 relative">
                  <div className="absolute -left-3.5 top-1 w-6 h-6 bg-primary rounded-full"></div>
                  <p className="font-semibold">2019</p>
                  <p>M.Ch (Urology) – Government Medical College & Transplant Institute, Kota, Rajasthan</p>
                </div>

              </div>
            </div>

            {/* EXPERIENCE */}
            <div className="bg-white rounded-3xl shadow-premium p-10 mb-8">
              <h3 className="text-2xl font-bold text-primary mb-8">Work Experience</h3>

              <div className="border-l-4 border-primary ml-4 space-y-8">

                <div className="pl-8 relative">
                  <div className="absolute -left-3.5 top-1 w-6 h-6 bg-primary rounded-full"></div>
                  <p className="font-semibold">2022 – Present</p>
                  <p>Consultant Urologist & Kidney Transplant Surgeon</p>
                  <p className="text-slate-500">Brajesh Bangad Memorial Hospital, Bhilwara Rajasthan</p>
                </div>

                <div className="pl-8 relative">
                  <div className="absolute -left-3.5 top-1 w-6 h-6 bg-primary rounded-full"></div>
                  <p className="font-semibold">2019 – 2022</p>
                  <p>M.Ch Senior Resident – Urology</p>
                  <p className="text-slate-500">Government Medical College & Transplant Institute, Kota, Rajasthan</p>
                </div>

                <div className="pl-8 relative">
                  <div className="absolute -left-3.5 top-1 w-6 h-6 bg-primary rounded-full"></div>
                  <p className="font-semibold">2018 – 2019</p>
                  <p>Senior Resident – Department of General Surgery</p>
                  <p className="text-slate-500">BJ Medical College & Sassoon Hospitals, Pune, Maharashtra</p>
                </div>

              </div>
            </div>

            {/* SPECIAL INTEREST */}
            <div className="bg-white rounded-3xl shadow-premium p-10 mb-8">
              <h3 className="text-2xl font-bold text-primary mb-6">Special Interest</h3>

              <ul className="grid md:grid-cols-2 gap-4 text-slate-700">
                <li>Kidney Stone Laser Surgery</li>
                <li>Kidney Transplant</li>
                <li>Prostate Surgery</li>
                <li>Male Infertility Treatment</li>
                <li>Endourology</li>
                <li>Laparoscopic Urology</li>
              </ul>
            </div>

            {/* AWARDS */}
            <div className="bg-white rounded-3xl shadow-premium p-10 mb-8">
              <h3 className="text-2xl font-bold text-primary mb-6">Awards & Honours</h3>

              <div className="space-y-4">
                <p><b>2024</b> – Faculty GBH National Oncology Conference</p>
                <p><b>2023</b> – Androcon Microsurgery Training</p>
                <p><b>2022</b> – Lasercon Workshop Participation</p>
                <p><b>2021</b> – RIRS & PCNL Advanced Training</p>
              </div>
            </div>

            {/* MEMBERSHIP */}
            <div className="bg-white rounded-3xl shadow-premium p-10">
              <h3 className="text-2xl font-bold text-primary mb-6">Membership</h3>

              <ul className="space-y-3 text-slate-700">
                <li>Urology Society of India (USI)</li>
                <li>Indian Medical Association (IMA)</li>
                <li>American Urology Association</li>
              </ul>
            </div>

            {/* OPD */}
            <div className="bg-primary text-white rounded-3xl p-10 text-center shadow-xl">
              <h3 className="text-3xl font-bold mb-6">OPD Timing</h3>
              <p className="text-lg">Monday – Saturday</p>
              <p className="text-xl font-semibold mt-2">9:00 AM – 5:00 PM</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
